module.exports = __webpack_public_path__ + "img/view_device_c2_one_en.18b60ad6.png";